
import React from 'react';
import { cn } from "@/lib/utils";
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

type EmailAuthFormProps = {
  email: string;
  setEmail: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  loading: boolean;
  isSignUp: boolean;
  onSubmit: (e: React.FormEvent) => void;
};

export const EmailAuthForm: React.FC<EmailAuthFormProps> = ({
  email,
  setEmail,
  password,
  setPassword,
  loading,
  isSignUp,
  onSubmit,
}) => {
  return (
    <form onSubmit={onSubmit} role="form" className={cn(
      "space-y-4 px-2 sm:px-4",
      "w-full"
    )} data-testid="email-auth-form">
      <div>
        <Label htmlFor="email" className="text-foreground">Email</Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          placeholder="Enter your email"
          disabled={loading}
          autoComplete="username"
        />
      </div>
      <div>
        <Label htmlFor="password" className="text-foreground">Password</Label>
        <Input
          id="password"
          type="password" 
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          placeholder="Enter your password"
          disabled={loading}
          autoComplete="current-password"
        />
      </div>
      <Button type="submit" className="w-full" disabled={loading}>
        {loading ? 'Loading...' : (isSignUp ? 'Create Account' : 'Sign In')}
      </Button>
    </form>
  );
};
